export default "__VITE_ASSET__D42Qcys8__"